// frontend/src/components/ManageAdspower.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import axios from 'axios';

export default function ManageAdspower() {
    const [config, setConfig] = useState({
        apiUrl: 'http://127.0.0.1:50325',
        apiKey: ''
    });
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');

    // Load saved config & cached profiles on mount
    useEffect(() => {
        const load = async () => {
            // Config
            const cDoc = await getDoc(doc(db, "settings", "adspower_config"));
            if (cDoc.exists()) setConfig(cDoc.data());

            // Cached Profiles
            const pDoc = await getDoc(doc(db, "settings", "adspower_profiles"));
            if (pDoc.exists()) setProfiles(pDoc.data().list || []);
        };
        load();
    }, []);

    const handleSync = async () => {
        setLoading(true);
        setStatus('Connecting to local API...');
        try {
            // 1. Save Config
            await setDoc(doc(db, "settings", "adspower_config"), config);

            // 2. Call Backend
            console.log("Sending request to backend...");
            const res = await axios.post('http://127.0.0.1:8000/api/adspower/fetch', config, { timeout: 15000 });
            
            console.log("📡 Raw Response:", res); 

            // 3. Robust Data Extraction
            // We default to empty object if res.data is null/undefined to prevent crashes
            const data = res.data || {};
            
            if (data.error) {
                 throw new Error(data.error);
            }

            const fetched = data.profiles || [];

            // 4. Save Cache
            await setDoc(doc(db, "settings", "adspower_profiles"), { list: fetched, lastSync: new Date() });
            
            setProfiles(fetched);
            setStatus(`Success! Synced ${fetched.length} profiles.`);

        } catch (error) {
            console.error("Sync Logic Failed:", error);
            const msg = error.response?.data?.detail || error.message || "Unknown Error";
            setStatus(`Error: ${msg}`);
        }
        setLoading(false);
    };

    return (
        <div className="admin-container">
            <h2>Manage Adspower</h2>
            
            <div style={{ background: '#252526', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                <h3 style={{ marginTop: 0 }}>Connection Settings</h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                    <div style={{ flex: 2 }}>
                        <label>Local API URL</label>
                        <input 
                            value={config.apiUrl} 
                            onChange={e => setConfig({...config, apiUrl: e.target.value})} 
                            placeholder="http://127.0.0.1:50325"
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label>API Key (Optional)</label>
                        <input 
                            value={config.apiKey} 
                            onChange={e => setConfig({...config, apiKey: e.target.value})} 
                            type="password"
                        />
                    </div>
                    <button onClick={handleSync} disabled={loading} style={{ padding: '10px 20px', background: '#007acc', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer' }}>
                        {loading ? 'Syncing...' : 'Sync Profiles'}
                    </button>
                </div>
                {status && <p style={{ marginTop: '10px', color: status.includes('Error') ? '#ff4444' : '#00ff00' }}>{status}</p>}
            </div>

            <div style={{ background: '#1e1e1e', padding: '20px', borderRadius: '8px', border: '1px solid #444' }}>
                <h3>Cached Profiles ({profiles.length})</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px', maxHeight: '400px', overflowY: 'auto' }}>
                    {profiles.map(p => (
                        <div key={p.user_id} style={{ padding: '10px', background: '#333', borderRadius: '4px', fontSize: '0.85rem' }}>
                            <div style={{ fontWeight: 'bold', color: '#fff' }}>{p.serial_number}</div>
                            <div style={{ color: '#aaa', marginBottom: '5px' }}>{p.user_id}</div>
                            <div style={{ color: '#007acc' }}>{p.name}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}